import Oidc, { UserManager, WebStorageStateStore } from "oidc-client";
import { Platform } from "quasar";
import CookieStorage, { Cookies } from "src/utils/CookieStorage";
import { boot } from "quasar/wrappers";
import { inIframe } from "src/utils";

let path = "",
  acrValues = "";

const isCordova = Platform?.is?.cordova;
path = `${location.protocol}//${location.hostname}${
  location.port ? ":" + location.port : ""
}`; // for cordova we use Localhost for InAppBrowser

acrValues = `${
  isCordova || process.env.DEV
    ? process.env.Tenant_ACR
    : `tenant:${location.hostname}`
}`;

export let oidc = null;

if (!inIframe()) {
  let settings = {
    authority: process.env.OIDC_AUTHORITY,
    client_id: process.env.OIDC_CLIENTID,
    redirect_uri: `${path}${process.env.OIDC_REDIRECT_URI}`,
    automaticSilentRenew: !isCordova && process.env.OIDC_AUTOMATIC_SILENT_RENEW,
    silent_redirect_uri: !isCordova
      ? `${path}${process.env.OIDC_SILENT_REDIRECT_URI}`
      : null,
    response_type: process.env.OIDC_RESPONSE_TYPE,
    scope: process.env.OIDC_SCOPE,
    post_logout_redirect_uri: `${path}${process.env.OIDC_POST_LOGOUT_URI}`,
    acr_values: acrValues,
    original_acr_values: acrValues,
    response_mode: process.env.OIDC_RESPONSE_MODE,
    loadUserInfo: true,
    popupWindowTarget: "",
    clockSkew: 300,
    userStore: new WebStorageStateStore({
      store: isCordova ? window.localStorage : new CookieStorage(Cookies),
    }),
    // clockSkew: 0,
    prompt: "login",
    popup_redirect_uri: `${path}${process.env.OIDC_REDIRECT_URI}`,
    popupWindowFeatures:
      "location=no,clearsessioncache=no,clearcache=no,cleardata=no",
    checkSessionInterval: 1000,
    monitorSession: !isCordova,
  };

  if (isCordova) {
    settings.popupNavigator = new Oidc.CordovaPopupNavigator();
    settings.iframeNavigator = new Oidc.CordovaIFrameNavigator();
  }

  oidc = new UserManager(settings);
}

export default boot(({ app }) => {
  app.provide("$oidc", oidc);
  app.config.globalProperties.$oidc = oidc;
});
